export const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    height: "48px",
    borderRadius: "8px",
    borderWidth: "1px",
    borderColor: "rgba(203, 212, 225, 1)",
    boxShadow: "none",
    padding: "0 4px",
    display: "flex",
    justifyContent: "space-between",
    "&:hover": {
      borderColor: "rgba(203, 212, 225, 1)",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: "white",
    color: "rgba(100, 116, 139, 1)",
    "&:hover": {
      backgroundColor: "rgba(244, 255, 220, 1)",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "rgba(100, 116, 139, 1)",
  }),
  menu: (provided) => ({
    ...provided,
    maxWidth: "424px",
    borderRadius: "8px",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "rgba(100, 116, 139, 1)",
  }),
};

// Varsa özel component'ler için tanım
export const customSelectComponents = {
  IndicatorSeparator: () => null,
  ClearIndicator: () => null,
};
